import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { fetchGiftcardCategories } from "../../../../features/auth/store/giftcardCategorySlice";
import GiftcardCategoriesTable from "./GiftcardCategoriesTable";
import { CreateGiftcardCategoryModal } from "../../Modal/Giftcard/CreateGiftcardCategoryModal";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { Button } from "../../../../components/Reusable/Button";
import { DeleteGiftcardCategoryModal } from "../../Modal/Giftcard/DeleteGiftcardCategoryModal";
import { EditGiftcardCategoryModal } from "../../Modal/Giftcard/EditGiftcardCategoryModal";

const ElectricCategories: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);

  const { giftcardCategories, loading, error } = useSelector(
    (state: RootState) => state.giftcardCategories
  );

  useEffect(() => {
    dispatch(fetchGiftcardCategories());
  }, [dispatch]);

  const openDeleteModal = async (id: number) => {
    setSelectedCategory(id);
    setIsDeleteModalOpen(true);
  };

  const openEditModal = async (id: number) => {
    setSelectedCategory(id);
    setIsEditModalOpen(true);
  };

  //   const handleDelete = async (id: number) => {
  //     try {
  //       await dispatch(deleteGiftcardCategory(id)).unwrap();
  //       toast.success("Category deleted!");
  //     } catch (err: any) {
  //       toast.error(err?.message || "Failed to delete category");
  //     }
  //   };

  // Filter and search logic
  const filteredCategories = giftcardCategories.filter((category) => {
    const matchesStatus = !statusFilter || category.status === statusFilter;
    const matchesSearch =
      !searchTerm ||
      category.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="Gift Card Categories">
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-4 mb-4 w-full">
              <input
                type="text"
                placeholder="Search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border p-2 rounded"
              />
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="border p-2 rounded"
              >
                <option value="">All Status</option>
                <option value="on">Active</option>
                <option value="off">Inactive</option>
              </select>
            </div>
            <Button
              onClick={() => setIsCreateModalOpen(true)}
              bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
              textColor="text-white"
              borderRadius="rounded-lg"
              className="w-[200px] h-10 ml-6"
            >
              New Category
            </Button>
          </div>

          <GiftcardCategoriesTable
            categories={filteredCategories}
            loading={loading}
            onDelete={openDeleteModal}
            onEdit={openEditModal}
          />

          <CreateGiftcardCategoryModal
            isOpen={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
          />

          <EditGiftcardCategoryModal
            isOpen={selectedCategory !== null && isEditModalOpen}
            id={selectedCategory}
            onClose={() => {
              setIsEditModalOpen(false);
              setSelectedCategory(null);
            }}
          />

          <DeleteGiftcardCategoryModal
            id={selectedCategory}
            isOpen={isDeleteModalOpen}
            onClose={() => {
              setIsDeleteModalOpen(false);
              setSelectedCategory(null);
            }}
          />
        </InternalContainer>
        {/* You can add an EditDataCategoryModal here, similar to Create */}
      </div>
    </ExternalContainer>
  );
};

export default ElectricCategories;
